import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';
import { useTranslation } from 'core/i18n/i18n';

export interface BulkDeleteMaterialComponentProps {
    onClick: VoidFunction;
}

export const BulkDeleteMaterialComponent: React.FC<BulkDeleteMaterialComponentProps> = ({ onClick }) => {
    const { t } = useTranslation();

    return (
        <BulkActionButtonComponent
            text={t('settings.materials.material-definitions.bulk-actions.actions.delete')}
            iconName="delete"
            onClick={onClick}
        />
    );
};
